package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.design.theme.AppSizes
import de.drick.compose.hotpreview.HotPreview

@Composable
fun EstimateMapRightColumn(
    modifier: Modifier,
    model: EstimateScreenModel
) {
    Column(
        modifier.padding(8.dp),
        verticalArrangement = Arrangement.spacedBy(
            AppSizes.map.cardVerticalPadding
        ),
        horizontalAlignment = Alignment.Start
    ) {
        EstimateIsExternalContract(
            Modifier.fillMaxWidth().height(IntrinsicSize.Min),
            model
        )

        HorizontalDivider(Modifier.fillMaxWidth())
        EstimateAreEnabled(
            Modifier.fillMaxWidth().height(IntrinsicSize.Min),
            model
        )

        HorizontalDivider(Modifier.fillMaxWidth())

        EstimateEndDateSelection(
            Modifier.fillMaxWidth().height(IntrinsicSize.Min),
            model
        )

        HorizontalDivider(Modifier.fillMaxWidth())

        EstimateSideEffectExplanation(
            Modifier.fillMaxWidth().height(IntrinsicSize.Min),
            model,
        )

        EstimateSkySentinelSwitch(
            Modifier.widthIn(170.dp, 200.dp)
                .height(AppSizes.map.cardImageAndTextHeight),
            model
        )

        EstimateConfigurationEmail(Modifier.fillMaxWidth(), model)
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun EstimateMapOverlayPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        EstimateMapOverlay(
            Modifier.fillMaxSize(),
            FakeEstimateScreenModel(false),
            rememberDrawerState(initialValue = DrawerValue.Closed) {
                false
            }
        )
    }
}
